<template>
  <div id="app">
    <!--导航条-->
    <gheader></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav></grednav>
    <!--登录一行-->
    <div id="carousel-generic" class="row-login carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carousel-generic" data-slide-to="0" class="active"></li>
        <li data-target="#carousel-generic" data-slide-to="1"></li>
        <!-- <li data-target="#carousel-generic" data-slide-to="2"></li> -->
      </ol>
      <div class="set-position" style="width: 100%;max-width: 1200px;margin: 0 auto;">
        <div class="log-in">
          <div>
            <p>{{welcome}}</p>
            <button class="form-control btn btn-default btn-login action"
                    @click="enterlink(enterWorkbench)">进入工作台
            </button>
            <button class="form-control btn btn-default btn-apply agreement"
                    @click="agreement()">供应商申请
            </button>
            <p>&nbsp;</p>
          </div>
          <hr/>
          <div style="margin-top: 5px">
            <h5 style="display: inline-block"><img src="static/imgs/helpCenter.png" alt=""/>&nbsp;帮助中心</h5>
            <p style="display: inline-block;float: right"><a href="manual.html" target="_blank">供应商操作手册</a></p>
          </div>
        </div>
      </div>
      <div class="carousel-inner" role="listbox" id="getOnfocus">
        <div class="item active">
          <div class="carousel-bg carousel-bg-jsqp2"></div>
        </div>
        <div class="item">
          <div class="carousel-bg carousel-bg-jsqp3"></div>
        </div>
        <!-- <div class="item">
          <div class="carousel-bg carousel-bg-jsqp4"></div>
        </div> -->
      </div>
    </div>
    <!--主要内容展示-->
    <div class="row-content" style="overflow-x: auto">
      <div class="main-width">
        <div class="bid-info pull-left">
          <div class="form-group">
            <infotable class="table-latest" v-bind:tableTitle="tableTitle[0]"
                       v-bind:tableContent="tableContent['latest']" v-bind:which="tableType[0]"
            ></infotable>
          </div>
          <div class="form-group">
            <infotable class="table-type" datatype="type" v-bind:tableTitle="tableTitle[2]"
                       v-bind:tableContent="tableContent['type']"
                       v-bind:which="tableType[2]"
            ></infotable>
          </div>
          <div class="form-group">
            <infotable class="table-orgName" datatype="orgName" v-bind:tableTitle="tableTitle[3]"
                       v-bind:tableContent="tableContent['orgName']" v-bind:which="tableType[0]"
            ></infotable>
          </div>
        </div>
        <div class="bid-notice pull-right">
          <div class="form-group">
            <notice type="bidding" :apiUrl="noticeUrl[1]" :num="2"></notice>
          </div>
          <div class="form-group">
            <notice type="company" :apiUrl="noticeUrl[0]" :ajaxType="'get'" :morelink="moreLink[0]"></notice>
          </div>
          <div class="form-group">
            <notice type="lbnotice" :apiUrl="noticeUrl[3]" :morelink="moreLink[1]"></notice>
          </div>
          <div class="form-group">
            <notice type="cqnotice" :apiUrl="noticeUrl[4]" :morelink="moreLink[2]"></notice>
          </div>
          <!--<div class="form-group">-->
            <!--<notice type="links" id="notice-links"></notice>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <!--合作供应商-->
    <!-- <gsupplier></gsupplier> -->
      <!--注册流程-->
    <regflows></regflows>
    <!--
    <div id="container" style="width: 100%; max-width: 1200px; margin: 0px auto;height:500px;margin-top:100px">
          
    </div>
    -->
    <!--footer-->
    <gfooter></gfooter>
    <!-- 提示框 -->
    <my-Dialog :title="title" :is-show="isShowDialog" @on-close="closeDialog('isShowDialog')">
      <p class="dialogmsg">{{tipMessager}}</p>
    </my-Dialog>
  </div>
</template>

<script>
  /*eslint-disable*/
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import gsupplier from 'components/G-supplier'
  import gfooter from 'components/G-footer'
  import notice from 'components/notice'
  import infotable from 'components/info-table'
  import {apiLinks} from 'src/api/links.js'
  import regflows from 'components/reg-flows'
  import MyDialog from 'components/Dialogs'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav,
      gsupplier,
      gfooter,
      notice,
      infotable,
      regflows,
      MyDialog
    },
    created: function () {
      // this.setCookie()
    },
    mounted: function () {
      this.start()
      window.localStorage.setItem('portaltype', apiLinks.portaltype)
      // 百度地图API功能
      // var map = new BMap.Map("container");    // 创建Map实例
      // //添加地图类型控件
      // var myGeo = new BMap.Geocoder();      
      // // 将地址解析结果显示在地图上，并调整地图视野    
      // myGeo.getPoint("四川省广安市广安区渠江北路86号", function(point){      
      //     if (point) {      
      //         map.centerAndZoom(point, 16);      
      //         map.addOverlay(new BMap.Marker(point));      
      //     }
      // }, 
      // "广安市");
      // map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
    },
    data () {
      return {
        welcome: apiLinks.welcome,
        cookieObj: {},
        southCement: apiLinks.southCement['home'],
        enterWorkbench: apiLinks.enterWorkbench,
        suppliersFor: apiLinks.suppliersFor,
        isShowDialog: false,
        title: '提示信息',
        tipMessager: '',
        tableTitle: [
          '最新采购信息',
          '按区域查看',
          '按类别查看',
          '按采购组织'
        ],
        tableContent: {
          latest: [
            '最新项目'
          ],
          area: [
            '全部',
            '上海',
            '浙江',
            '江西',
            '湖南',
            '广西',
            '江苏',
            '安徽',
            '福建'
          ],
          type: [
            '全部'
          ],
          orgName: [
            '全部'
          ]
        },
        tableType: [
          'latest',
          'area',
          'type',
          'orgName'
        ],
        noticeUrl: [
          apiLinks.notice['company'],
          apiLinks.notice['bidding'],
          '2',
          apiLinks.notice['lbnotice'],
          apiLinks.notice['cqnotice']
        ],
        moreLink: [
          apiLinks.details.noticeMore,
          apiLinks.details.lbnoticeMore,
          apiLinks.details.cqnoticeMore
        ]
      }
    },
    methods: {
      closeDialog () {
        this.isShowDialog = false
      },
      enterlink: function (href) {
        window.location.href = href
      },
      agreement: function () {
        var self = this
        //开发环境没有user，测试及正式环境有
        if(window.parent.localStorage.user){
          var supEntId = $.parseJSON(window.parent.localStorage.user).user.enterpriseId
          var url = apiLinks.agreement + "&supEntId=" + supEntId
          this.$http.get(url).then(function (res) {
            if(res.data.data){
              self.tipMessager = '您已经申请过了，请进入工作台，查看您的申请单'
              self.isShowDialog = true
            }else{
              window.location.href = "agreement.html?applyFor"
            }
          });
        }else{
          window.location.href = "agreement.html?applyFor"
        }
      },
      openlink: function (href) {
        window.open(href)
      },
      setCookie: function () {
        let cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
          let item = cookies[i].split('=')
          let key = item[0].trim()
          if (key) {
            this.cookieObj[key] = item[1]
          }
        }
      },
      getCookie: function () {
        this.$http.jsonp('http://yc.yonyou.com/yuncai/jsonp/setCookie', [{cookieObj: this.cookieObj}]).then(function (response) {
          console.log('setCookie:1')
        }, function (response) {
          console.log('setCookie:0')
        })
      },
      getCustomers: function () {
//        this.$http.jsonp(apiLinks.tableDate[1], []).then(function (response) {
//          this.infos = response.data[0]['result']
//        }, function (response) {
//        })
      },
      start: function () {
        let vm = this
        let promise = new Promise(function (resolve, reject) {
          resolve()
        })
        promise.then(function () {
          vm.getCustomers()
        })
      }
    }
  }
</script>
<style lang="less">
  @import '../home/home.less';

  .home-li-a {
    display: none;
  }

  .cashome-li-a {
    display: block !important;
  }
  .agreement{
    color:#0386c1;
  }
  .dialogmsg {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// cashome.vue?4c7e9d88